import type { INotifyQueue, Notify } from './types'

export class NotifyQueue implements INotifyQueue {
  private notifies: Notify[] = []

  private flushing: boolean = false

  addNotify(notify: Notify) {
    this.notifies.push(notify)
  }

  removeNotify(id: string) {
    this.notifies = this.notifies.filter(notify => notify.id !== id)
  }

  nextNotify() {
    const notify = this.notifies.shift()
    if (notify) {
      this.flushing = true
      notify.callback()
    }
    else {
      this.flushing = false
    }
  }

  getLength() {
    return this.notifies.length
  }

  getFlushing() {
    return this.flushing
  }
}
